import { useMemo } from 'react';
import { PolymarketMarket } from '@/components/predic/detail/market/types';

export interface UseFilteredMarketsOptions {
  markets?: PolymarketMarket[];
  isClosed?: boolean;
  sortBy?: string;
}

export default function useFilteredMarkets({
  markets = [],
  isClosed = false,
}: UseFilteredMarketsOptions) {
  return useMemo(() => {
    if (isClosed) return markets;

    return sortMarketsByResolutionAndPrice(markets);
  }, [isClosed, markets]);
}

function sortMarketsByResolutionAndPrice(markets: PolymarketMarket[]) {
  return markets
    .map((market, index) => ({ market, index }))
    .sort((left, right) => {
      const leftResolved = isResolved(left.market);
      const rightResolved = isResolved(right.market);

      if (leftResolved !== rightResolved) {
        return leftResolved ? 1 : -1;
      }

      const priceDiff =
        toNumber(right.market.outcome_yes_price) - toNumber(left.market.outcome_yes_price);
      return priceDiff || left.index - right.index;
    })
    .map(({ market }) => market);
}

function isResolved(market: PolymarketMarket) {
  return market.uma_resolution_status === 'resolved';
}

function toNumber(value?: string | number | null) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
}
